import request from '../../utils/request';
import { Result } from '../../models/general';
import type {
    LifecycleTemplateView,
    LifecycleTemplateInput,
    DuplicateTemplateInput,
    TemplateCategory,
} from '../../models/employee';

export async function getTemplates(category: TemplateCategory): Promise<Result<LifecycleTemplateView[]>> {
    const response = await request.get<Result<LifecycleTemplateView[]>>(`LifecycleTemplates/GetTemplates?category=${category}`);
    return response.data;
}

export async function getTemplate(id: number): Promise<Result<LifecycleTemplateView>> {
    const response = await request.get<Result<LifecycleTemplateView>>(`LifecycleTemplates/GetTemplate/${id}`);
    return response.data;
}

export async function createTemplate(input: LifecycleTemplateInput): Promise<Result<LifecycleTemplateView>> {
    const response = await request.post<Result<LifecycleTemplateView>>('LifecycleTemplates/CreateTemplate', input);
    return response.data;
}

export async function updateTemplate(id: number, input: LifecycleTemplateInput): Promise<Result<LifecycleTemplateView>> {
    const response = await request.put<Result<LifecycleTemplateView>>(`LifecycleTemplates/UpdateTemplate/${id}`, input);
    return response.data;
}

export async function deleteTemplate(id: number): Promise<Result<boolean>> {
    const response = await request.delete<Result<boolean>>(`LifecycleTemplates/DeleteTemplate/${id}`);
    return response.data;
}

export async function duplicateTemplate(id: number, input: DuplicateTemplateInput): Promise<Result<LifecycleTemplateView>> {
    const response = await request.post<Result<LifecycleTemplateView>>(`LifecycleTemplates/DuplicateTemplate/${id}`, input);
    return response.data;
}

export async function setDefaultTemplate(id: number): Promise<Result<boolean>> {
    const response = await request.post<Result<boolean>>(`LifecycleTemplates/SetDefaultTemplate/${id}`);
    return response.data;
}
